import React, { useState, useEffect, useRef } from 'react';
import './App.css';

const AnalogClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const seconds = time.getSeconds() * 6;
  const minutes = time.getMinutes() * 6 + seconds / 60;
  const hours = time.getHours() % 12 * 30 + minutes / 12;

  return (
    <div className="analog-clock">
      <div className="hand hour-hand" style={{transform: `rotate(${hours}deg)`}}></div>
      <div className="hand minute-hand" style={{transform: `rotate(${minutes}deg)`}}></div>
      <div className="hand second-hand" style={{transform: `rotate(${seconds}deg)`}}></div>
      {[...Array(12)].map((_, i) => (
        <div key={i} className="hour-mark" style={{transform: `rotate(${i * 30}deg)`}}></div>
      ))}
    </div>
  );
};

const Oscilloscope = () => {
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    const initAudio = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        analyserRef.current = audioContextRef.current.createAnalyser();
        const source = audioContextRef.current.createMediaStreamSource(stream);
        source.connect(analyserRef.current);
      } catch (error) {
        console.error('Error accessing microphone:', error);
      }
    };

    const draw = () => {
      const { width, height } = canvas;
      ctx.clearRect(0, 0, width, height);
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'rgb(255, 255, 255)'; // Changed to white
      ctx.beginPath();

      if (analyserRef.current) {
        const bufferLength = analyserRef.current.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);
        analyserRef.current.getByteTimeDomainData(dataArray);

        const sliceWidth = width * 1.0 / bufferLength;
        let x = 0;

        for (let i = 0; i < bufferLength; i++) {
          const v = dataArray[i] / 128.0;
          const y = v * height / 2;

          if (i === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }

          x += sliceWidth;
        }
      }

      ctx.lineTo(canvas.width, canvas.height / 2);
      ctx.stroke();

      animationFrameId = requestAnimationFrame(draw);
    };

    initAudio();
    draw();

    return () => {
      cancelAnimationFrame(animationFrameId);
      if (audioContextRef.current) {
        audioContextRef.current.close();
      }
    };
  }, []);

  return <canvas ref={canvasRef} className="oscilloscope" />;
};

function App() {
  return (
    <div className="App">
      <div className="clock-container">
        <Oscilloscope />
        <AnalogClock />
      </div>
      <a href="https://11000ad.com" target="_blank" rel="noopener noreferrer" className="site-link">
        11000ad.com
      </a>
    </div>
  );
}

export default App;
